import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CommercialCondition,
  CommercialConditionFormData,
  COMMERCIAL_CONDITION_TYPE_MAP
} from '../models/commercial-condition.model';
import { BaseCrudService, PaginatedResponse } from './base-crud.service';

@Injectable({
  providedIn: 'root'
})
export class CommercialConditionsService extends BaseCrudService<CommercialCondition, CommercialConditionFormData> {

  protected override useMock = false;
  protected endpoint = 'commercial-conditions';

  // Override getAll para transformar enum
  override getAll(
    page: number = 1,
    perPage: number = 10,
    filters: { [key: string]: any } = {},
    sortField?: string,
    sortOrder?: number
  ): Observable<PaginatedResponse<CommercialCondition>> {
    return super.getAll(page, perPage, filters, sortField, sortOrder).pipe(
      map(response => ({
        ...response,
        data: response.data.map(item => ({
          ...item,
          type_label: COMMERCIAL_CONDITION_TYPE_MAP[item.type]
        }))
      }))
    );
  }

  // Override getById para transformar enum
  override getById(id: number): Observable<CommercialCondition | undefined> {
    return super.getById(id).pipe(
      map(item => {
        if (!item) return undefined;
        return {
          ...item,
          type_label: COMMERCIAL_CONDITION_TYPE_MAP[item.type]
        };
      })
    );
  }

  protected mockData: CommercialCondition[] = [
    {
      id: 1,
      code: 'CC001',
      name: 'Condición Comercial 01',
      description: 'Pago anticipado',
      type: 'upfront',
      is_active: true,
      created_at: '2026-02-06T21:15:57Z',
      updated_at: undefined,
      created_by: 1,
      updated_by: undefined
    },
    {
      id: 2,
      code: 'CC002',
      name: 'Condición Comercial 02',
      description: 'Pago diferido a 30 días',
      type: 'deferred',
      is_active: true,
      created_at: '2026-02-06T21:15:57Z',
      updated_at: undefined,
      created_by: 1,
      updated_by: undefined
    },
    {
      id: 3,
      code: 'CC003',
      name: 'Condición Comercial 03',
      description: 'Pago diferido a 60 días',
      type: 'deferred',
      is_active: true,
      created_at: '2026-02-06T21:15:57Z',
      updated_at: undefined,
      created_by: 1,
      updated_by: undefined
    },
    {
      id: 4,
      code: 'CC004',
      name: 'Condición Comercial 04',
      description: 'Pago anticipado con descuento',
      type: 'upfront',
      is_active: false,
      created_at: '2026-02-06T21:15:57Z',
      updated_at: undefined,
      created_by: 1,
      updated_by: undefined
    },
    {
      id: 5,
      code: 'CC005',
      name: 'Condición Comercial 05',
      description: 'Pago diferido a 90 días',
      type: 'deferred',
      is_active: true,
      created_at: '2026-02-06T21:15:57Z',
      updated_at: undefined,
      created_by: 1,
      updated_by: undefined
    }
  ];
}
